import axios from 'axios'

//采摘批次任务列表(PC)
export function getInspectionSheet (id) {
  return axios.get(`/manage/inspectionSheet/${id}`)
}

export function selectEarliestInspectionTime (data) {
  return axios.get(`/manage//inspectionSheet/selectEarliestInspectionTime`, { params: data })
}